import { renderLineBreaks } from "../../../utils";
import { NextImage } from "../../elements";
import { Section } from "../index";
import { ContentWrapper } from "./styles";

const Title = ({ title }) => {
  return <h1>{title}</h1>;
};

export const PageTitle = ({
  sectionTitle,
  sectionSubtitle,
  hideLineSeparation,
  title,
  image,
  displaySetting
}) => {
  return (
    <Section
      title={sectionTitle}
      subtitle={sectionSubtitle}
      hideLine={hideLineSeparation}
      displayMode={displaySetting?.displayMode}
      smallMargin={displaySetting?.smallBottomMargin}
    >
      <ContentWrapper hasImage={!!image}>
        {title && <Title title={renderLineBreaks(title)} />}
        {image && <NextImage media={image} />}
      </ContentWrapper>
    </Section>
  );
};

export default PageTitle;
